import { __decorate } from "tslib";
import __NG_CLI_RESOURCE__0 from "./create-application-details-bpams.component.html?ngResource";
import __NG_CLI_RESOURCE__1 from "./create-application-details-bpams.component.scss?ngResource";
import { ChangeDetectorRef, Component } from "@angular/core";
import { CreateApplicationViewBaseComponent } from "../../../shared/create-application-view-base/create-application-view-base.component";
import { ApplicationCreateService } from "../../../shared/application-create.service";
import { AflaModuleStrategyService } from "../../../../shared/services/afla-module-strategy/afla-module-strategy.service";
import { Validators } from "@angular/forms";
import { CreateApplicationDetailsBpamsConstants } from "./create-application-details-bpams.constants";
import { SharedConstants } from "../../../../shared/constants/shared.constants";
import { CRUDOperation } from "../../../../shared/models/crud-operation-enum.model";
import { AppControllerService } from "../../../../app-controller.service";
import { SelectedApplicationService } from "../../../../shared/services/selected-application/selected-application.service";
import { SearchApplicationsService } from "../../../../search-applications/shared/search-applications.service";
let CreateApplicationDetailsBpamsComponent = class CreateApplicationDetailsBpamsComponent extends CreateApplicationViewBaseComponent {
    applicationCreateService;
    aflaModuleStrategyService;
    selectedApplicationService;
    appController;
    changeDetectorRefs;
    searchApplicationsService;
    detailsForm;
    validationMessages = CreateApplicationDetailsBpamsConstants.VALIDATION_MESSAGES;
    dropdownPlaceholderMessage = SharedConstants.PLACEHOLDER_TEXT;
    descriptionFormControlName = CreateApplicationDetailsBpamsConstants.DESCRIPTION_FORM_CONTROL_NAME;
    descriptionLabel = CreateApplicationDetailsBpamsConstants.DESCRIPTION_LABEL;
    isMinorBuildingWorkLabel = CreateApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_LABEL;
    isResidentialApplicationLabel = CreateApplicationDetailsBpamsConstants.IS_RESIDENTIAL_APPLICATION_LABEL;
    otherBuildingUseLabel = CreateApplicationDetailsBpamsConstants.OTHER_BUILDING_USE_LABEL;
    isAlterationsLabel = CreateApplicationDetailsBpamsConstants.IS_ALTERATIONS_LABEL;
    buildingUseLabel = CreateApplicationDetailsBpamsConstants.BUILDING_USE_LABEL;
    sectorLabel = CreateApplicationDetailsBpamsConstants.SECTOR_LABEL;
    isRdpLabel = CreateApplicationDetailsBpamsConstants.IS_RDP_LABEL;
    rdpHouseCountLabel = CreateApplicationDetailsBpamsConstants.RDP_HOUSE_COUNT_LABEL;
    applicationTypeLabel = CreateApplicationDetailsBpamsConstants.APPLICATION_TYPE_LABEL;
    estimatedByLabel = CreateApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_BY_LABEL;
    estimatedCostLabel = CreateApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_COST_LABEL;
    previousReferenceNumberLabel = CreateApplicationDetailsBpamsConstants.PREVIOUS_REFERENCE_NUMBER_LABEL;
    isResubmissionLabel = CreateApplicationDetailsBpamsConstants.IS_RESUBMISSION_LABEL;
    isExtensionLabel = CreateApplicationDetailsBpamsConstants.IS_EXTENSION_LABEL;
    nonResidentialBuildingUseLookupName = CreateApplicationDetailsBpamsConstants.NON_RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME;
    residentialBuildingUseLookupName = CreateApplicationDetailsBpamsConstants.RESIDENTIAL_BUILDING_USE_OPTION_LOOKUP_NAME;
    typeOptionsLookupName = CreateApplicationDetailsBpamsConstants.TYPE_OPTION_LOOKUP_NAME;
    estimatedByOptionsLookupName = CreateApplicationDetailsBpamsConstants.ESTIMATED_BY_OPTION_LOOKUP_NAME;
    buildingUseOptionsLookupName = CreateApplicationDetailsBpamsConstants.BUILDING_USE_OPTION_LOOKUP_NAME;
    isMinorBuildingWorkFormControlName = CreateApplicationDetailsBpamsConstants.IS_MINOR_BUILDING_WORK_FORM_CONTROL_NAME;
    isResidentialApplicationFormControlName = CreateApplicationDetailsBpamsConstants.IS_RESIDENTIAL_APPLICATION_CONTROL_NAME;
    isAlterationsFormControlName = CreateApplicationDetailsBpamsConstants.IS_ALTERATIONS_CONTROL_NAME;
    isBuildingUseOtherFormControlName = CreateApplicationDetailsBpamsConstants.IS_BUILDING_USE_OTHER_CONTROL_NAME;
    buildingTypeFormControlName = CreateApplicationDetailsBpamsConstants.BUILDING_TYPE_CONTROL_NAME;
    sectorFormControlName = CreateApplicationDetailsBpamsConstants.SECTOR_FORM_CONTROL_NAME;
    isRdpFormControlName = CreateApplicationDetailsBpamsConstants.IS_RDP_FORM_CONTROL_NAME;
    rdpHouseCountFormControlName = CreateApplicationDetailsBpamsConstants.RDP_HOUSE_COUNT_FORM_CONTROL_NAME;
    buildingUseFormControlName = CreateApplicationDetailsBpamsConstants.BUILDING_USE_FORM_CONTROL_NAME;
    applicationTypeFormControlName = CreateApplicationDetailsBpamsConstants.APPLICATION_TYPE_FORM_CONTROL_NAME;
    estimatedByFormControlName = CreateApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_BY_FORM_CONTROL_NAME;
    estimatedCostFormControlName = CreateApplicationDetailsBpamsConstants.APPLICATION_ESTIMATED_COST_FORM_CONTROL_NAME;
    previousReferenceNumberFormControlName = CreateApplicationDetailsBpamsConstants.PREVIOUS_APPLICATION_REFERENCE_NUMBER_FORM_CONTROL_NAME;
    isResubmissionFormControlName = CreateApplicationDetailsBpamsConstants.IS_RESUBMISSION_FORM_CONTROL_NAME;
    isExtensionFormControlName = CreateApplicationDetailsBpamsConstants.IS_EXTENSION_FORM_CONTROL_NAME;
    yesNoOptions = [];
    sectorOptions = [];
    buildingUseOptions = [];
    applicationTypeOptions = [];
    estimatedByOptions = [];
    nonResidentialBuildingUseOptions = [];
    residentialBuildingUseOptions = [];
    selectedApplicationBpamsSubscription;
    markStepFormGroupAsTouchedSubscription;
    formGroupName = CreateApplicationDetailsBpamsConstants.DETAILS_FORM_GROUP_NAME;
    showBuildingTypeField = false;
    constructor(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, appController, changeDetectorRefs, searchApplicationsService) {
        super(applicationCreateService, aflaModuleStrategyService, selectedApplicationService, searchApplicationsService);
        this.applicationCreateService = applicationCreateService;
        this.aflaModuleStrategyService = aflaModuleStrategyService;
        this.selectedApplicationService = selectedApplicationService;
        this.appController = appController;
        this.changeDetectorRefs = changeDetectorRefs;
        this.searchApplicationsService = searchApplicationsService;
    }
    ngOnInit() {
        this.initForm();
        this.getMetadata();
        if (this.aflaModuleStrategyService.lookups.has("sectorOptions") &&
            this.aflaModuleStrategyService.lookups.get(this.buildingUseOptionsLookupName) &&
            this.aflaModuleStrategyService.lookups.get(this.typeOptionsLookupName) &&
            this.aflaModuleStrategyService.lookups.get(this.estimatedByOptionsLookupName)) {
            this.sectorOptions = this.aflaModuleStrategyService.lookups.get("sectorOptions");
            this.buildingUseOptions = this.aflaModuleStrategyService.lookups.get("buildingUseOptions");
            this.applicationTypeOptions = this.aflaModuleStrategyService.lookups.get("applicationTypeOptions");
            this.estimatedByOptions = this.aflaModuleStrategyService.lookups.get("estimatedByOptions");
            this.yesNoOptions = [];
            this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
            this.subscribeToSelectedApplication();
        }
        else {
            this.getLookups();
        }
        this.setupSubscribers();
    }
    loadMetadata(stepMeta) {
    }
    initForm() {
        this.detailsForm = this.aflaModuleStrategyService.form.get(this.formGroupName);
        this.initialiseBuildingUseFields();
        this.updateQuantityOfHousesState(false);
    }
    getLookups() {
        const params = {
            $filter: `moduleId eq ${this.applicationCreateService.moduleID} and (name eq 'ResidentialBuildingUse' or name eq 'NonResidentialBuildingUse' or name eq 'BuildingSector' or name eq 'ApplicationType' or name eq 'PropertyEstimatedBy' and deleted eq false)`
        };
        this.applicationCreateService
            .getLookupsObservable(params)
            .subscribe((response) => this.onGetLookupsCompleted(response), (error) => {
            this.appController.handleServerErrorMessage(CreateApplicationDetailsBpamsConstants.STEP_TITLE, error, CRUDOperation.Get);
        });
    }
    onGetLookupsCompleted(response) {
        const nonResidentialBuildingUse = [];
        const residentialBuildingUse = [];
        const sector = [];
        const applicationType = [];
        const estimatedBy = [];
        if (response && response.value.length > 0) {
            response.value.forEach(item => {
                if (item.name === "NonResidentialBuildingUse") {
                    nonResidentialBuildingUse.push(JSON.parse(item.content));
                }
                if (item.name === "ResidentialBuildingUse") {
                    residentialBuildingUse.push(JSON.parse(item.content));
                }
                if (item.name === "BuildingSector") {
                    sector.push(JSON.parse(item.content));
                }
                if (item.name === "ApplicationType") {
                    applicationType.push(JSON.parse(item.content));
                }
                if (item.name === "PropertyEstimatedBy") {
                    estimatedBy.push(JSON.parse(item.content));
                }
            });
        }
        nonResidentialBuildingUse.sort((a, b) => a.value.localeCompare(b.value));
        residentialBuildingUse.sort((a, b) => a.value.localeCompare(b.value));
        sector.sort((a, b) => a.value.localeCompare(b.value));
        applicationType.sort((a, b) => a.value.localeCompare(b.value));
        estimatedBy.sort((a, b) => a.value.localeCompare(b.value));
        this.yesNoOptions = [];
        this.yesNoOptions = Object.values(SharedConstants.YES_NO_ENUM);
        this.aflaModuleStrategyService.lookups.set(this.nonResidentialBuildingUseLookupName, nonResidentialBuildingUse);
        this.nonResidentialBuildingUseOptions = nonResidentialBuildingUse;
        this.aflaModuleStrategyService.lookups.set(this.residentialBuildingUseLookupName, residentialBuildingUse);
        this.residentialBuildingUseOptions = residentialBuildingUse;
        this.aflaModuleStrategyService.lookups.set("sectorOptions", sector);
        this.sectorOptions = sector;
        this.aflaModuleStrategyService.lookups.set("applicationTypeOptions", applicationType);
        this.applicationTypeOptions = applicationType;
        this.aflaModuleStrategyService.lookups.set("estimatedByOptions", estimatedBy);
        this.estimatedByOptions = estimatedBy;
        this.changeDetectorRefs.detectChanges();
        this.subscribeToSelectedApplication();
    }
    subscribeToSelectedApplication() {
        this.selectedApplicationBpamsSubscription = this.selectedApplicationService.$selectedApplication.subscribe((application) => {
            if (application) {
                this.setApplicationDetails(application);
            }
        });
    }
    setApplicationDetails(application) {
        // checks the application has application details set
        if (application.description) {
            this.detailsForm.get(this.descriptionFormControlName).setValue(application.description);
        }
        if (application.isMinorBuildingWork) {
            this.detailsForm.get(this.isMinorBuildingWorkFormControlName).setValue(application.isMinorBuildingWork);
        }
        if (application.buildingType) {
            this.detailsForm.get(this.buildingTypeFormControlName).setValue(application.buildingType);
        }
        if (application.isAlterations) {
            this.detailsForm.get(this.isAlterationsFormControlName).setValue(application.isAlterations);
        }
        if (application.isResidential) {
            this.detailsForm.get(this.isResidentialApplicationFormControlName).setValue(application.isResidential);
        }
        if (application.isResidential?.toLowerCase().trim() === "yes") {
            this.getBuildingUseFromResidentialBuildingUse();
        }
        if (application.isResidential?.toLowerCase().trim() === "no") {
            this.nonResidentialApplicationSelected();
        }
        if (application.sector) {
            this.detailsForm.get(this.sectorFormControlName).setValue(application.sector);
        }
        if (application.isRdp) {
            this.detailsForm.get(this.isRdpFormControlName).setValue(application.isRdp);
        }
        if (application.rdpHouseCount !== undefined && application.rdpHouseCount !== null) {
            this.detailsForm.get(this.rdpHouseCountFormControlName).setValue(application.rdpHouseCount);
        }
        this.updateQuantityOfHousesState(false);
        if (application.applicationType) {
            this.detailsForm.get(this.applicationTypeFormControlName).setValue(application.applicationType);
        }
        if (application.applicationEstimatedBy) {
            this.detailsForm.get(this.estimatedByFormControlName).setValue(application.applicationEstimatedBy);
        }
        if (application.applicationEstimatedCost) {
            this.detailsForm.get(this.estimatedCostFormControlName).setValue(application.applicationEstimatedCost);
        }
        if (application.isResubmission) {
            this.detailsForm.get(this.isResubmissionFormControlName).setValue(application.isResubmission);
        }
        if (application.isExtension) {
            this.detailsForm.get(this.isExtensionFormControlName).setValue(application.isExtension);
        }
        if (application.previousReferenceNumber) {
            this.detailsForm.get(this.previousReferenceNumberFormControlName).setValue(application.previousReferenceNumber);
        }
        this.buildingUseOptions.forEach(item => {
            if (item.value === application.buildingUse) {
                this.detailsForm.get("buildingUse").setValue(item.value);
            }
        });
        if (application.buildingUse !== null && application.buildingUse !== undefined && application.buildingUse.toLowerCase().trim() === "other") {
            this.otherApplicationIsSelected();
            this.detailsForm.get(this.buildingTypeFormControlName).setValue(application.buildingType);
        }
        else {
            this.detailsForm.get(this.buildingTypeFormControlName).clearValidators();
            this.detailsForm.get(this.buildingTypeFormControlName).updateValueAndValidity();
            this.showBuildingTypeField = false;
        }
        this.applicationTypeOptions.forEach(item => {
            if (item.value === application.applicationType) {
                this.detailsForm.get("applicationType").setValue(item.value);
            }
        });
        this.changeDetectorRefs.detectChanges();
    }
    setupSubscribers() {
        this.subscribeToCheckFormValidity();
    }
    subscribeToCheckFormValidity() {
        this.markStepFormGroupAsTouchedSubscription = this.applicationCreateService.$markStepFormGroupAsTouchedSubscription.subscribe({
            next: (formGroupName) => {
                if (formGroupName && this.detailsForm && formGroupName === this.formGroupName) {
                    this.detailsForm.markAllAsTouched();
                    this.changeDetectorRefs.markForCheck();
                }
            }
        });
    }
    getBuildingUseFromResidentialBuildingUse() {
        this.buildingUseOptions = [];
        this.detailsForm.get(this.buildingUseFormControlName).enable();
        this.buildingUseOptions = this.residentialBuildingUseOptions;
        this.aflaModuleStrategyService.lookups.set(this.buildingUseOptionsLookupName, this.buildingUseOptions);
        this.detailsForm.get(this.buildingTypeFormControlName).reset();
        this.showBuildingTypeField = false;
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(false);
        this.detailsForm.updateValueAndValidity();
    }
    nonResidentialApplicationSelected() {
        this.buildingUseOptions = [];
        this.detailsForm.get(this.buildingUseFormControlName).enable();
        this.buildingUseOptions = this.nonResidentialBuildingUseOptions;
        this.aflaModuleStrategyService.lookups.set(this.buildingUseOptionsLookupName, this.buildingUseOptions);
        this.detailsForm.get(this.buildingTypeFormControlName).reset();
        this.showBuildingTypeField = false;
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(false);
        this.detailsForm.updateValueAndValidity();
    }
    otherApplicationIsSelected() {
        this.detailsForm.get(this.isBuildingUseOtherFormControlName).setValue(true);
        this.detailsForm.get(this.buildingTypeFormControlName).addValidators(Validators.required);
        this.detailsForm.get(this.buildingTypeFormControlName).updateValueAndValidity();
        this.showBuildingTypeField = true;
    }
    onIsRdpChanged() {
        this.updateQuantityOfHousesState(true);
    }
    updateQuantityOfHousesState(clearValue) {
        const rdpHouseCountControl = this.detailsForm.get(this.rdpHouseCountFormControlName);
        if (!rdpHouseCountControl) {
            return;
        }
        if (this.isYes(this.detailsForm.get(this.isRdpFormControlName).value)) {
            rdpHouseCountControl.setValidators(Validators.required);
            rdpHouseCountControl.enable();
        }
        else {
            if (clearValue) {
                rdpHouseCountControl.setValue(null);
            }
            rdpHouseCountControl.disable();
        }
        rdpHouseCountControl.updateValueAndValidity();
    }
    isYes(value) {
        return value?.toLowerCase().trim() === SharedConstants.YES_NO_ENUM.Yes.toLowerCase();
    }
    isResidentialChanged($event) {
        const isResidential = $event.target.value;
        if (isResidential?.toLowerCase().trim() === "yes") {
            this.getBuildingUseFromResidentialBuildingUse();
        }
        if (isResidential?.toLowerCase().trim() === "no") {
            this.nonResidentialApplicationSelected();
        }
    }
    buildingUseChanged($event) {
        const buildingUseValue = $event.target.value;
        if (buildingUseValue?.toLowerCase().trim() === "other") {
            this.otherApplicationIsSelected();
        }
        else {
            this.detailsForm.get(this.buildingTypeFormControlName).clearValidators();
            this.detailsForm.get(this.buildingTypeFormControlName).updateValueAndValidity();
            this.showBuildingTypeField = false;
        }
        this.detailsForm.updateValueAndValidity();
        this.changeDetectorRefs.detectChanges();
    }
    initialiseBuildingUseFields() {
        const otherBusinessUse = this.detailsForm.get(this.isBuildingUseOtherFormControlName).value;
        const buildingUse = this.detailsForm.get(this.buildingUseFormControlName).value;
        if (otherBusinessUse) {
            this.showBuildingTypeField = true;
        }
        else {
            this.showBuildingTypeField = false;
        }
        if (buildingUse) {
            this.detailsForm.get(this.buildingUseFormControlName).enable();
        }
        else {
            this.detailsForm.get(this.buildingUseFormControlName).disable();
        }
    }
    static ctorParameters = () => [
        { type: ApplicationCreateService },
        { type: AflaModuleStrategyService },
        { type: SelectedApplicationService },
        { type: AppControllerService },
        { type: ChangeDetectorRef },
        { type: SearchApplicationsService }
    ];
};
CreateApplicationDetailsBpamsComponent = __decorate([
    Component({
        selector: "app-create-application-details-bpams",
        template: __NG_CLI_RESOURCE__0,
        styles: [__NG_CLI_RESOURCE__1]
    })
], CreateApplicationDetailsBpamsComponent);
export { CreateApplicationDetailsBpamsComponent };
